import Markdown from "react-markdown";
import { getButtonAppearance } from "utils/button";

import ButtonLink from "../elements/button-link";

import styles from "@/styles/cta.module.scss";

const Cta = ({ data }) => {
  const bg =
    data.mobileBackgroundColor === "white" ? "bg-transparent" : "bg-onmoBeige";
  // const source = data.content.replace(":", "\n ");
  return (
    <section
      className={`${bg} md:bg-onmoBeige text-center pt-14 pb-20 md:py-28 px-5 md:px-20 flex flex-col gap-12 md:gap-20`}
    >
      <Markdown className={styles.text}>{data.content}</Markdown>
      {data.button ? (
        <ButtonLink
          updated
          size={data.button.size}
          button={data.button}
          appearance={getButtonAppearance(data.button.type)}
        />
      ) : null}
    </section>
  );
};

export default Cta;
